
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBatteryIcon as ObcBatteryIconElement} from '@oicl/openbridge-webcomponents/dist/components/battery-icon/battery-icon.js';
 
 
 

 
 export const ObcBatteryIcon = createComponent({
   react: React,
   tagName: 'obc-battery-icon',
   elementClass: ObcBatteryIconElement,
   events: {
     
   }
  });
 
 